import { render, staticRenderFns } from "./promocode.vue?vue&type=template&id=a96020c0&scoped=true&"
import script from "./promocode.vue?vue&type=script&lang=js&"
export * from "./promocode.vue?vue&type=script&lang=js&"
import style0 from "./promocode.vue?vue&type=style&index=0&id=a96020c0&lang=scss&scoped=true&"
import style1 from "./promocode.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./promocode.vue?vue&type=style&index=2&id=a96020c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96020c0",
  null
  
)

export default component.exports